export default "__VITE_ASSET__29738208__"